
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { css } from '../../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js';

var tag = function tag(_ref) {
  var typeScaleSizes = _ref.typeScaleSizes,
    tag = _ref.tag;
  return /*#__PURE__*/ /*#__PURE__*/css("display:inline-flex;align-items:center;font-size:", typeScaleSizes.sm, ";line-height:normal;padding:0.5rem;background-color:", tag.backgroundColor, ";color:", tag.color, ";border-radius:5px;white-space:nowrap;" + (process.env.NODE_ENV === "production" ? "" : ";label:tag;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFNEUiLCJmaWxlIjoic3R5bGVzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3NzLCBUaGVtZSwgU2VyaWFsaXplZFN0eWxlcyB9IGZyb20gXCJAZW1vdGlvbi9yZWFjdFwiO1xuXG5leHBvcnQgY29uc3QgdGFnID0gKHsgdHlwZVNjYWxlU2l6ZXMsIHRhZyB9OiBUaGVtZSk6IFNlcmlhbGl6ZWRTdHlsZXMgPT4gY3NzYFxuICBkaXNwbGF5OiBpbmxpbmUtZmxleDtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgZm9udC1zaXplOiAke3R5cGVTY2FsZVNpemVzLnNtfTtcbiAgbGluZS1oZWlnaHQ6IG5vcm1hbDtcbiAgcGFkZGluZzogMC41cmVtO1xuICBiYWNrZ3JvdW5kLWNvbG9yOiAke3RhZy5iYWNrZ3JvdW5kQ29sb3J9O1xuICBjb2xvcjogJHt0YWcuY29sb3J9O1xuICBib3JkZXItcmFkaXVzOiA1cHg7XG4gIHdoaXRlLXNwYWNlOiBub3dyYXA7XG5gO1xuIl19 */", process.env.NODE_ENV === "production" ? "" : ";label:tag;");
};

export { tag };
//# sourceMappingURL=styles.js.map
